import React, { Component, Fragment } from 'react';

class FileDownload extends Component {
  render() {
    const { fileInfoList } = this.props;
    
    return (
      <Fragment>
      {fileInfoList.map((fileInfo,idx)=>{
        return(
          <Fragment key={idx}>
            <div style={{ marginLeft: '20px', marginTop: '5px'}}>
              <a href={process.env.REACT_APP_URL+`/file/fileDownload/?fileName=${encodeURIComponent(fileInfo.fileName)}&serverSubPath=${fileInfo.serverSubPath}&physicalName=${fileInfo.physicalName}`}>
              {fileInfo.fileName !== undefined && fileInfo.fileName !== null && fileInfo.fileName}
              </a>
            </div>
          </Fragment>
        );
      })}
      </Fragment>
    );
  }

}

export default FileDownload;
